// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { createContext, useState, FC, useMemo } from 'react';
import moment from 'moment';
import { IntlProvider } from 'react-intl'
import { useEffect } from 'react';
import { Messages } from './type';
import messageZh from './zh-tw';
import messageEn from './en';
import sendActiveEpic from '../../redux/epics/sendActiveEpic';

type LangContextState = {
  lang: string;
  messages: Messages;
  setLang: (lang: string) => void;
};

const contextDefaultValues: LangContextState = {
  lang: navigator.language || 'zh-tw',
  messages: messageZh,
  setLang: () => { /** Empty */ }
};

export const LangContext = createContext<LangContextState>(contextDefaultValues);

export const LangContextProvider: FC = ({ children }) => {
  const setting = localStorage.getItem('language');

  const [lang, setLang] = useState(setting || navigator.language || 'zh-tw');
  const [messages, setMessage] = useState<Messages>(messageZh);

  useEffect(() => {
    let locale;
    switch (lang) {
      case 'en':
      case 'en-us':
      case 'en-US':
        locale = 'en';
        setMessage(messageEn);
        break;
      case 'zh':
      case 'zh-tw':
      case 'zh-TW':
      default:
        locale = 'zh-tw';
        setMessage(messageZh);
        break;
    }
    localStorage.setItem('language', locale);
    setLang(locale);
    moment.locale(locale);
  }, [lang]);

  const value = useMemo(() => {
    return {
      lang,
      messages,
      setLang,
    }
  }, [lang, messages, setLang])

  return (
    <LangContext.Provider value={value}>
      <IntlProvider locale={lang} messages={messages as unknown as Record<string, string>}>
        {children}
      </IntlProvider>
    </LangContext.Provider>
  );
};

export default LangContext;
